// ─────────────────────────────────────────────────────────────────────────────
// Utilidades mínimas de JWT en el cliente. NO verifican la firma (eso es del backend): solo leen
// el payload para decidir cosas locales — si un token está cerca de expirar, sobre todo.
// ─────────────────────────────────────────────────────────────────────────────

/** `exp` (epoch en segundos) del payload de un JWT, o `null` si no es legible. */
export function readJwtExp(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as { exp?: number };
    return typeof json.exp === 'number' ? json.exp : null;
  } catch {
    return null;
  }
}

/**
 * `true` si al token le quedan menos de `skewMs` para expirar (o ya expiró). Si el `exp` no es
 * legible devuelve `false`: sin dato fiable, se prefiere intentar usar el token y dejar que el
 * servidor decida con un 401 real, en vez de descartarlo por si acaso.
 */
export function isJwtExpiringSoon(token: string, skewMs = 30_000): boolean {
  const exp = readJwtExp(token);
  if (exp === null) return false;
  return Date.now() >= exp * 1000 - skewMs;
}
